var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconOverView = function SvgIconOverView(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5h11.68V7.82H4.5zm0 3.32h11.68v-1.64H4.5zm0 3.36h11.68V14.5H4.5zm13.32 0h1.68V14.5h-1.68zm0-8.36V9.5h1.68V7.82zm0 5h1.68v-1.64h-1.68z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconOverView);
export { ForwardRef as ReactComponent };